import { Grid } from '@material-ui/core';
import { Field } from 'formik';
import React, { Fragment } from 'react';
import createShowIf from 'v2/components/Shared/createShowIf';
import { SwitchFormField } from 'v2/components/Shared/FormFields/SwitchFormField';
import { TextFormField } from 'v2/components/Shared/FormFields/TextFormField';

import type { Recovery as RecoveryClass } from '../../classes/Payment';

interface IProps {
  errors: any;
  handleChange: any;
  getHelperText: any;
  getError: any;
  values: RecoveryClass;
  setFocus: any;
}

const Recovery = ({ setFocus, handleChange, values }: IProps) => {
  const ShowIfRecovery = createShowIf<RecoveryClass>();

  return (
    <Fragment>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid item xs={12}>
            <Field
              id='sales_recovery'
              name='sales_recovery'
              label='Recuperar vendas perdidas'
              onMouseEnter={setFocus}
              checked={values.sales_recovery}
              onChange={handleChange}
              component={SwitchFormField}
            />
          </Grid>
          <ShowIfRecovery value={values} compare={{ eq: { sales_recovery: true } }}>
            <Grid item xs={12}>
              <Field label='Nome do remetente de e-mail' name='recovery_email' id='recovery_email' onFocus={setFocus} component={TextFormField} />
            </Grid>
          </ShowIfRecovery>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default Recovery;
